class SafeLoadScripts extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (this.dataset.loadOn === 'visible' && 'IntersectionObserver' in window) {
      const target = this.parentElement || this;
      const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          observer.disconnect();
          this.loadScripts();
        }
      }, { rootMargin: '600px 0px' });

      observer.observe(target);
      return;
    }

    this.loadScripts();
  }

  loadScripts() {
    const scripts = this.querySelectorAll('safe-load-scripts > script');

    scripts.forEach((script) => {
      const key = script.dataset.flowLoadKey;

      const scriptLoaded = key ? window.wetheme.webcomponentRegistry.checkScriptLoaded(key) : false;
      if(!scriptLoaded) {
        if (key) {
          window.wetheme.webcomponentRegistry.registry[key] = { key };
        }

        const postLoadedScript = document.createElement('script');
        const src = script.dataset.src || script.src;
        const defer = script.defer;
        const async = script.async;
        const type = script.dataset.scriptType || script.type;

        if (!src) {
          return;
        }

        postLoadedScript.src = src;
        postLoadedScript.defer = defer;
        postLoadedScript.async = async;
        postLoadedScript.type = type;


        this.parentElement.appendChild(postLoadedScript);

      }
    })

  }
}
  
customElements.define('safe-load-scripts', SafeLoadScripts);
